import { Keyboard, KeyboardInfo, KeyboardResize } from '@capacitor/keyboard';
import { DomHelper } from '../helpers/dom.helper';

export class KeyboardServiceIos {
    public static async start() {
        await Keyboard.setResizeMode({ mode: KeyboardResize.None });

        await Keyboard.addListener('keyboardWillShow', async (e: KeyboardInfo) => {
            this.addClassToDOM(e.keyboardHeight);
            this.addSpaceAtBottom();

            const activeElement = document.activeElement;
            if (activeElement && activeElement instanceof HTMLElement) {
                // Trouver le ion-content parent
                const ionContent = activeElement.closest('ion-content');
                if (!ionContent) return;

                // Attendre que le ion-content soit prêt
                await ionContent.componentOnReady?.();

                const scrollElement = await (ionContent as any).getScrollElement();
                if (!scrollElement) return;

                // Calculer la position absolue de l'élément dans le scrollElement
                const scrollElementRect = scrollElement.getBoundingClientRect();
                const elementRect = activeElement.getBoundingClientRect();

                const keyboardHeight = e.keyboardHeight;
                const viewportHeight = window.innerHeight;
                const availableHeight = viewportHeight - keyboardHeight;

                // Position actuelle du scroll
                const currentScrollTop = scrollElement.scrollTop;

                // Position absolue de l'élément dans le document scrollable
                const elementAbsoluteTop =
                    elementRect.top - scrollElementRect.top + currentScrollTop;

                // Position relative au viewport
                const elementViewportTop = elementRect.top;
                const elementViewportBottom = elementRect.bottom;

                // Vérifier si l'élément est caché par le clavier ou hors de vue
                if (elementViewportBottom > availableHeight || elementViewportTop < 0) {
                    // Calculer la position pour centrer l'élément dans l'espace visible
                    const targetScrollTop =
                        elementAbsoluteTop + availableHeight / 2 + elementRect.height / 2;
                    await ionContent.scrollToPoint(0, Math.max(0, targetScrollTop), 0);
                }
            }
        });

        await Keyboard.addListener('keyboardWillHide', () => {
            this.removeSpaceAtBottom();
        });
    }

    public static async stop() {
        await Keyboard.removeAllListeners();
    }

    private static addClassToDOM(keyboardHeight: number) {
        let css = `ion-content {
                            --padding-bottom: revert;
                            padding-bottom: revert;
                        }

                        ion-content.with-keyboard {
                            --padding-bottom: ${keyboardHeight}px !important;
                            padding-bottom: ${keyboardHeight}px !important;
                        }`;

        DomHelper.addOrReplaceCustomCSS(css);
    }

    private static addSpaceAtBottom() {
        const footers = document.querySelectorAll('ion-content');
        if (footers.length > 0) {
            const lastFooter = footers[footers.length - 1];
            lastFooter.classList.add('with-keyboard');
        }
    }

    private static removeSpaceAtBottom() {
        const footers = document.querySelectorAll('ion-content');
        if (footers.length > 0) {
            const lastFooter = footers[footers.length - 1];
            lastFooter.classList.remove('with-keyboard');
        }
    }
}
